import React from 'react';
import {UseIoC} from "../composers/composer-plugins/use-ioc";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";

export const HeaderDateSelectorComposer = (DateSelector) => UseIoC()((props) => {
  const datetimeUtils: DatetimeUtils = props.ioc.getInstance(DatetimeUtils);

  const isToday = datetimeUtils.isToday(props.date);
  const displayDate = datetimeUtils.toShortNamedDate(props.date);
  const displayEndDate = datetimeUtils.toShortNamedDate(props.endDate);

  const newProps = {
    ...props,
    isToday,
    displayDate,
    displayEndDate
  }

  return <DateSelector {...newProps} />;
});
